/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Cash = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 5V19H1V5H23ZM21.5 6.5H2.5V17.5H21.5V6.5ZM12.564 7.765V8.584C13.671 8.773 14.391 9.493 14.445 10.537H13.077C13.005 10.141 12.618 9.763 11.988 9.763C11.448 9.763 11.124 9.979 11.124 10.348C11.124 10.681 11.376 10.843 11.754 10.951L12.735 11.221C13.671 11.491 14.481 11.914 14.481 13.219C14.481 14.254 13.743 14.983 12.564 15.136V16H11.421V15.109C10.269 14.893 9.504 14.056 9.45 12.85H10.818C10.872 13.471 11.394 13.957 12.06 13.957C12.654 13.957 13.059 13.678 13.059 13.255C13.059 12.886 12.762 12.67 12.366 12.553L11.394 12.283C10.467 12.031 9.693 11.563 9.693 10.357C9.693 9.457 10.395 8.773 11.421 8.584V7.765H12.564ZM7 11.25V12.75H4V11.25H7ZM20 11.25V12.75H17V11.25H20Z"
                        fill={color}
                    />
                </svg>
        );
    };
